import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
  fetchChaptersThunk,
  createChapterThunk,
  updateChapterThunk,
  deleteChapterThunk,
} from "./chapterThunk";

const initialState = {
  classes: [],
  subjects: [],
  chapters: [],
  selectedClassId: "",
  selectedSubjectId: "",
  selectedChapterId: "",
  loadingClasses: false,
  loadingSubjects: false,
  loadingChapters: false,
  chapterName: "",
  editingChapter: null,
  loader: false,
};

const chapterSlice = createSlice({
  name: "chapter",
  initialState,
  reducers: {
    setSelectedClassId: (state, action) => {
      state.selectedClassId = action.payload;
    },
    setSelectedSubjectId: (state, action) => {
      state.selectedSubjectId = action.payload;
    },
    setSelectedChapterId: (state, action) => {
      state.selectedChapterId = action.payload;
    },
    setChapterName: (state, action) => {
      state.chapterName = action.payload;
    },
    setEditingChapter: (state, action) => {
      state.editingChapter = action.payload;
    },
    setSubjects: (state, action) => {
      state.subjects = action.payload;
    },
    setChapters: (state, action) => {
      state.chapters = action.payload;
    },
    setClasses: (state, action) => {
      state.classes = action.payload;
    },
  },

  extraReducers: (builder) => {
    // Fetch Classes
    createThunkCases(
      builder,
      fetchClassesThunk,
      null,
      "Error Getting Classes",
      (state, action) => {
        state.classes = action.payload.map((e) => ({
          value: e.class_id,
          label: e.class_name,
        }));
      }
    );
    // Fetch Subjects
    createThunkCases(
      builder,
      fetchSubjectsByClassThunk,
      null,
      "Error Getting Subjects",
      (state, action) => {
        state.subjects = action.payload.map((e) => ({
          value: e.subject_id,
          label: e.subject_name,
        }));
      }
    );
    // .addCase(fetchSubjectsByClassThunk.pending, (state) => {
    //   state.loadingSubjects = true;
    // })
    // .addCase(fetchSubjectsByClassThunk.fulfilled, (state, action) => {
    //   state.subjects = action.payload;
    //   state.loadingSubjects = false;
    // })
    // .addCase(fetchSubjectsByClassThunk.rejected, (state) => {
    //   state.loadingSubjects = false;
    // })

    // Fetch Chapters
    // .addCase(fetchChaptersThunk.pending, (state) => {
    //   state.loadingChapters = true;
    // })
    // .addCase(fetchChaptersThunk.fulfilled, (state, action) => {
    //   state.chapters = action.payload;
    //   state.loadingChapters = false;
    // })
    // .addCase(fetchChaptersThunk.rejected, (state) => {
    //   state.loadingChapters = false;
    // })
    createThunkCases(
      builder,
      fetchChaptersThunk,
      null,
      "Error Getting Class Subject Chapters",
      (state, action) => {
        state.chapters = action.payload.map((e) => ({
          value: e.chapter_id,
          label: e.chapter_name,
        }));
      }
    );
    builder

      // Create Chapter
      .addCase(createChapterThunk.fulfilled, (state, action) => {
        state.chapters.push(action.payload);
      })

      // Update Chapter
      .addCase(updateChapterThunk.fulfilled, (state, action) => {
        const index = state.chapters.findIndex(
          (c) => c.chapter_id === action.payload.chapter_id
        );
        if (index !== -1) {
          state.chapters[index] = action.payload;
        }
      })

      // Delete Chapter
      .addCase(deleteChapterThunk.fulfilled, (state, action) => {
        state.chapters = state.chapters.filter(
          (c) => c.chapter_id !== action.payload
        );
      });
  },
});

export const {
  setSelectedClassId,
  setSelectedSubjectId,
  setSelectedChapterId,
  setChapterName,
  setEditingChapter,
  setSubjects,
  setChapters,
  setClasses,
} = chapterSlice.actions;

export const createThunkCases = (
  builder,
  thunk,
  targetKey = null,
  customErrorMsg,
  extraChanges = null,
  errorChanges = null
) => {
  builder
    .addCase(thunk.pending, (state, action) => {
      state.loader = true;
      state.error = null;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.loader = false;
      state.error = null;
      if (targetKey) {
        state[targetKey] = action.payload;
      }

      if (typeof extraChanges === "function") {
        extraChanges(state, action);
      }
    })
    .addCase(thunk.rejected, (state, action) => {
      state.loader = false;
      state.error = action?.payload || action?.error?.message || customErrorMsg;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    });
};
export default chapterSlice.reducer;
